import { Component, Element, h } from '@stencil/core';
import {loadInitData} from '../../utils/start';
import { NjRouteProperties } from '../nj-router/NjRouteProperties';
import '@oebb-web-team/oebb-web-components';

@Component({
  tag: 'nj-search-root',
  styleUrl: 'nj-search-root.css',
  shadow: true,
})
export class NjSearchRoot {

  lang: string;

  @Element() el: HTMLElement;

  routes: NjRouteProperties[] = [
    { path: "/", component: "nj-home", params: { showFormOnly: true } },
    { path: "/home", component: "nj-home" , params: { showFormOnly: true }},
  ];

  async componentWillLoad(){
    let langItems: NodeList = document.querySelectorAll("ul.lang-nav > li > a")

    langItems.forEach((item:Node) => {
      let linkItem:HTMLLinkElement = item as HTMLLinkElement

      linkItem.href =  linkItem.href + location.hash;

    });

    await loadInitData(this.el);
  }

  render() {
    return (
      <div class="base-padding">
        <div>
          <nj-router routes={this.routes}></nj-router>
        </div>
      </div>
    );
  }

}
